import type { PostType } from 'common/actions/queueItemQueries';

export const PostTypes: { name: PostType; label: string }[] = [
  { name: 'newPost', label: 'New posts' },
  { name: 'duplicate', label: 'Duplicates' },
];
